import DialogComponent from "../../../../../common/components/functional/dialogs/DialogComponent";
import { FringeBenefitForm } from "./FringeBenefitForm";
import { FringeBenefit, FringeBenefitType } from "./types";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (fringeBenefit: FringeBenefit) => void;
  fringeBenefits: FringeBenefit[];
  selectedFringeBenefit: FringeBenefit | null;
  fringeBenefitTypes: FringeBenefitType[];
};

export const FringeBenefitDialog = ({
  isOpen,
  onClose,
  onSave,
  fringeBenefits,
  selectedFringeBenefit,
  fringeBenefitTypes,
}: Props) => {
  return (
    <DialogComponent
      open={isOpen}
      onClose={onClose}
      autoWidth
      sx={{
        borderRadius: "4px",
        minWidth: "600px",
        maxWidth: "600px",
      }}
    >
      {isOpen && (
        <FringeBenefitForm
          close={onClose}
          onSave={onSave}
          fringeBenefits={fringeBenefits}
          selectedFringeBenefit={selectedFringeBenefit}
          fringeBenefitTypes={fringeBenefitTypes}
        />
      )}
    </DialogComponent>
  );
};
